import BolivarIcon from './BolivarIcon';

export default BolivarIcon;
